import React from 'react'

// MATERIAL
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'


export default class Location extends React.Component{
    render(){
    return(
        <div>
            <div>
                <Typography className="title" style={{color: 'white', marginBottom: 10}} variant="title">
                    Location
                </Typography>
            </div>
                <Typography style={{color: 'white'}} variant="body-2">
                    <SvgIcon style={{marginRight: 7, display: 'inline-flex', alignSelf: 'center', top: '.25em', position: 'relative'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                    </SvgIcon>
                    Paraguay 4747 - Palermo Soho - CABA
                </Typography>  
        </div>
    )
  }
}
   


// WEBPACK FOOTER //
// ./src/Components/Footer/Parts/Location.js